var _excluded = ["size", "color", "onClick", "cursor", "display", "data-test-name", "aria-label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react"; // DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details

import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import { colorNessieResponsivePropType, oneOfNessieResponsivePropType } from "../../propTypes";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";

var PaintBrushIcon = function PaintBrushIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? "m" : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "shale" : _ref$color,
      onClick = _ref.onClick,
      cursor = _ref.cursor,
      _ref$display = _ref.display,
      display = _ref$display === void 0 ? "inline-block" : _ref$display,
      dataTestName = _ref["data-test-name"],
      ariaLabel = _ref["aria-label"],
      props = _objectWithoutProperties(_ref, _excluded);

  var sizeInPixels = SIZES[size];
  var ButtonOrSpan = onClick ? UnstyledButton : "span";
  return _jsx(ButtonOrSpan, {
    "aria-label": ariaLabel,
    "data-test-name": dataTestName,
    onClick: onClick,
    sx: {
      fontSize: sizeInPixels,
      display: display,
      lineHeight: 0,
      color: color,
      cursor: cursor,
      position: "relative"
    },
    children: _jsxs("svg", _objectSpread(_objectSpread({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {}, {
      children: [_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.961 10.699l7.779-9.243a1.278 1.278 0 011.805-.153c.541.458.61 1.268.152 1.81l-7.777 9.243a2.087 2.087 0 01-.446 1.774l-.691.95c-.521-1.36-1.5-2.225-2.501-2.712a6.39 6.39 0 00-.483-.215l.494-.716a2.072 2.072 0 011.668-.738zM9.402 13.56c.26.085.525.188.784.319.965.495 1.848 1.276 2.209 2.722l-.046.053c-.207 4.629-5.252 6.446-8.086 6.342-2.862-.106-3.524-2.441-3.18-2.47.072-.007.175-.002.299.003.895.039 2.94.127 3.306-3.307.293-2.763 3.821-3.558 4.714-3.662z"
      }), _jsx("mask", {
        maskUnits: "userSpaceOnUse",
        x: 1,
        y: 1,
        width: 22,
        height: 22,
        children: _jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.961 10.699l7.779-9.243a1.278 1.278 0 011.805-.153c.541.458.61 1.268.152 1.81l-7.777 9.243a2.087 2.087 0 01-.446 1.774l-.691.95c-.521-1.36-1.5-2.225-2.501-2.712a6.39 6.39 0 00-.483-.215l.494-.716a2.072 2.072 0 011.668-.738zM9.402 13.56c.26.085.525.188.784.319.965.495 1.848 1.276 2.209 2.722l-.046.053c-.207 4.629-5.252 6.446-8.086 6.342-2.862-.106-3.524-2.441-3.18-2.47.072-.007.175-.002.299.003.895.039 2.94.127 3.306-3.307.293-2.763 3.821-3.558 4.714-3.662z"
        })
      })]
    }))
  });
};

var SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px"
};
PaintBrushIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"])
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  PaintBrushIcon = nessiePropCheckerWrapper(PaintBrushIcon);
}

export default PaintBrushIcon;
//# sourceMappingURL=PaintBrushIcon.js.map